export default function EmptyCreditCheckCard() {
  return (
    <div className="quoteform__option">
      <div className="optioncard">
        <div className="optioncard__header">
          <span>Credit Check Option</span>
        </div>
        <div className="optioncard__body">
          <p>Want to explore all your options? Share your credit score with us to view and compare additional quotes that may be even more affordably priced.</p>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanCards/components/EmptyCreditCheckCard.js